/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "car-hatchback-17371287--sprite",
  "use": "car-hatchback-17371287--sprite-usage",
  "viewBox": "0 0 47 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 47 21\" id=\"car-hatchback-17371287--sprite\"><path d=\"M2 8l.89 7.124a1 1 0 00.993.876H7M2 8l6.707-6.707A1 1 0 019.414 1H15.5M2 8h13.5M36 8h5a5 5 0 015 5v2a1 1 0 01-1 1h-5m-4-8l-7.717-6.753A1 1 0 0027.624 1H15.5M36 8H15.5M40 16a4 4 0 01-8 0m8 0a4 4 0 00-8 0m0 0H15m0 0a4 4 0 01-8 0m8 0a4 4 0 00-8 0m8.5-8V1\" stroke=\"#000\" stroke-width=\"2\" /><path d=\"M30 14l4-6H16l3 6h11zM2.5 10H5v2H3m43-1h-3l-3-3\" stroke=\"#000\" stroke-width=\".75\" /></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
